import { useContext } from 'react';
import { RetryContext } from './RetryContext';
import { Callout } from '@cimpress-ui/react';

export const RetryAlert = () => {
  const { retryError, setRetryError, retryState, retryRoutingRequest } = useContext(RetryContext);

  const clearRetryError = () => {
    retryRoutingRequest?.reset();
    setRetryError(undefined);
  };

  if (retryError) {
    return (
      <Callout
        tone="critical"
        isDismissible={true}
        onDismiss={() => clearRetryError()}
        data-testid="retry-error-alert"
        data-cim-style-root
      >{`There was an error retrying the routing request: ${retryError.message}.`}</Callout>
    );
  }

  if (retryState === 'DONE') {
    return (
      <Callout
        isDismissible={true}
        tone="success"
        onDismiss={() => retryRoutingRequest?.reset()}
        data-testid="retry-success-alert"
        data-cim-style-root
      >
        The routing request was retried successfully.
      </Callout>
    );
  }

  return null;
};
